import { render, staticRenderFns } from "./whyDia.vue?vue&type=template&id=77cd7659&scoped=true&"
import script from "./whyDia.vue?vue&type=script&lang=js&"
export * from "./whyDia.vue?vue&type=script&lang=js&"
import style0 from "./whyDia.vue?vue&type=style&index=0&id=77cd7659&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cd7659",
  null
  
)

export default component.exports